/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VisibleInSchedule/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function VisibleInSchedule({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Edit/VisibleInSchedule",
  onChange
  
}) {
let editedNoteVisibleInScheduleValueData = fromData.useDataValue({ viewPath,
context: 'edited_note',
path: 'visible_in_schedule',
})
let editedNoteVisibleInScheduleChangeData = fromData.useDataChange({ viewPath,
context: 'edited_note',
path: 'visible_in_schedule',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="edited_note.visible_in_schedule"
 value={editedNoteVisibleInScheduleValueData}
 onChange={editedNoteVisibleInScheduleChangeData}
 marginTop={0}
 marginBottom={dtSpaceXxxs}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 size="small"
 color={dtColorsNeutral900}
 text="Visible in schedule"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}